import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { gileClassesFetchGet } from '../../../../api-client/api-gqadmin-client';

const initialState = {
    loading: false,
    error: null,
    data: null,
};

export const getGileClassesFetch = createAsyncThunk(
    'getGileClassesFetch/Get',
    async (body, { rejectWithValue }) => {
        try {
            const response = await gileClassesFetchGet(body);
            const data = response?.data;
            return data;
        } catch (err) {
            const errObj = {
                type: 'GET_GQ_ADMIN_GILE_CLASSES_FETCH_FAILURE',
                error: err,
                message: 'Oops! something went wrong',
            };
            return rejectWithValue(err?.response?.data || errObj);
        }
    },
);

const getGileClassesFetchSlice = createSlice({
    name: 'getGileClassesFetch',
    initialState,
    extraReducers: {
        [getGileClassesFetch.pending]: (state) => {
            state.loading = true;
        },
        [getGileClassesFetch.fulfilled]: (state, { payload }) => {
            state.loading = false;
            state.data = payload?.data;
            state.error = null;
        },
        [getGileClassesFetch.rejected]: (state, { payload }) => {
            state.loading = false;
            state.data = null;
            state.error = payload;
        },
    },
});

export const getGileClassesFetchSelector = (state) => state.getGileClassesFetch;
export const getGileClassesFetchReducer = getGileClassesFetchSlice.reducer;
